import { useCookies } from 'react-cookie';
import { useRootSelector } from '../../../../../store/hooks';
import { selectPageConfig } from '../../../../../store/features/pageConfig';
import { canCookieBeSecure } from '../../../../../helpers';

export function useBasketCookie() {
  const [cookies, setCookie, removeCookie] = useCookies([
    'basket_id',
    'basket_order',
  ]);
  const { cookieSitePath } = useRootSelector(selectPageConfig);

  const setBasketIdToCookie = (basketId: string) => {
    setCookie('basket_id', basketId, {
      expires: new Date(Date.now() + 86400000),
      path: cookieSitePath,
      secure: canCookieBeSecure(),
    });
  };

  const removeBasketIdCookie = () => {
    removeCookie('basket_id', {
      path: cookieSitePath,
      secure: canCookieBeSecure(),
    });
  };

  const removeOrderIdCookie = () => {
    removeCookie('basket_order', {
      path: cookieSitePath,
      secure: canCookieBeSecure(),
    });
  };

  return {
    basketCreated:
      cookies.basket_id && cookies.basket_order === cookies.basket_id,
    basketId: cookies.basket_id,
    orderId: cookies.basket_order,
    setBasketIdToCookie,
    removeBasketIdCookie,
    removeOrderIdCookie,
  };
}
